import { getCssSizeValue, getMapKey, getPaddingsClassFromData } from "@/utils/utils"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"
import GridContainer from "@/components/common/GridContainer"
import styled from "styled-components"
import TypographyBannerItem from "@/components/Banners/Typography/TypographyBannerItem"
import { insetPaddingLeftCss, insetPaddingRightCss } from "@/styles/globalStyles"
import { TYPOGRAPHY_BANNER_VARIANTS } from "@/constants"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Container = styled(GridContainer)`
	position: relative;
	${insetPaddingLeftCss};
	${insetPaddingRightCss};
	--bg-color: ${({ theme }) => theme.colors.white};
	background: var(--bg-color);
	padding: ${getCssSizeValue(45, BREAKPOINTS.MOBILE)} 0 ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	row-gap: ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		row-gap: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
		padding: ${getCssSizeValue(45, BREAKPOINTS.DESKTOP)} 0 ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)};
	}

	&.${TYPOGRAPHY_BANNER_VARIANTS.GRAY} {
		--bg-color: ${({ theme }) => theme.colors.platinum};
	}
`

function getData(src) {
	return {
		paddings: getPaddingsClassFromData(src),
		items: src?.items || [],
		variant: src?.variant || TYPOGRAPHY_BANNER_VARIANTS.WHITE,
		headerDescription: src?.headerDescription || null,
	}
}

export default function Typography({ data }) {
	const { paddings, items, variant, headerDescription } = getData(data)

	return (
		<section className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<Container className={`${variant}`}>
				{items.map((item, i) => (
					<TypographyBannerItem key={getMapKey(item, i)} item={item} variant={variant} />
				))}
			</Container>
		</section>
	)
}
